module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.count > 0) ? _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.paths), function(val, index) {
    return _c('li', {
      class: {
        'active': index == (_vm.count - 1)
      }
    }, [(index == (_vm.count - 1)) ? _c('strong', [(index == 0) ? _c('span', [_vm._v("位置：")]) : _vm._e(), _vm._v(_vm._s(val.name))]) : _vm._e(), _vm._v(" "), (index == 0 && index != (_vm.count - 1)) ? _c('a', [_c('span', [_vm._v("位置：")]), _vm._v(_vm._s(val.name))]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-062c392c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/bread-crumb.vue
// module id = 203
// module chunks = 1